require.register("ffss/ui/modal/Choice", function(exports, require, module){
  $0
  
});

